// Entirely offline: a bundled Census cartographic boundary file (cb_2023_us_state_5m, the 50 states
// only — DC and territories excluded by his "one of the 50 US states" rule), simplified to ~10%
// (visvalingam keep-shapes, ~147 KB) and LAZY-LOADED via dynamic import so the map app never pays
// for it — the chunk downloads the first time a Section 180 export runs.
import {
  pointInPolygons,
  polygonsOf,
  type PolygonRings,
} from "./samplingDesign";

type StateFeature = { st: string; polys: PolygonRings[] };
let statesPromise: Promise<StateFeature[]> | null = null;

function loadStates(): Promise<StateFeature[]> {
  statesPromise ??= import("./data/usStates.json").then((mod) => {
    const fc = (mod.default ?? mod) as GeoJSON.FeatureCollection;
    return fc.features.map((f) => ({
      st: String((f.properties as { st: string }).st),
      polys: polygonsOf(f.geometry) as PolygonRings[],
    }));
  });
  return statesPromise;
}

/* * Two-letter abbreviation of the state containing the point, or null when no state contains it. */
export async function stateOfPoint(
  lon: number,
  lat: number,
): Promise<string | null> {
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
  const states = await loadStates();
  return (
    states.find((s) => pointInPolygons({ lng: lon, lat }, s.polys))?.st ?? null
  );
}
